import React from 'react'
import {Form, Input} from "antd";

const StockFilters = () => {

    return(
        <React.Fragment>
            <Form.Item
                name={'name'}
                label={'Stok Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'code'}
                label={'Stok Kodu'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'brandName'}
                label={'Marka'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
        </React.Fragment>
    )
}
export default StockFilters